import * as yup from "yup";

const STATUSES = ["Pending", "In Progress", "Completed"]; 
const PRIORITIES = ["High", "Medium", "Low"]; 

export const electionTaskSchema = yup.object().shape({
  title: yup
    .string()
    .trim()
    .required("Task name is required")
    .max(200, "Task name must be at most 200 characters"),
  description: yup
    .string()
    .trim()
    .max(1000, "Description must be at most 1000 characters")
    .optional(),
  dueDate: yup
    .string()
    .nullable()
    .matches(/^$|^\d{4}-\d{2}-\d{2}$/,{ message: "Due Date must be YYYY-MM-DD" }),
  status: yup
    .string()
    .oneOf(STATUSES, "Invalid status"),
  priority: yup
    .string()
    .oneOf(PRIORITIES, "Invalid priority"),
});

export async function validateElectionTask(data) {
  try {
    const validated = await electionTaskSchema.validate(data, { abortEarly: false });
    return { valid: true, values: validated, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner && Array.isArray(err.inner)) {
      err.inner.forEach((e) => {
        if (e.path && !errors[e.path]) {
          errors[e.path] = e.message;
        }
      });
    } else if (err.path) {
      errors[err.path] = err.message;
    }
    return { valid: false, values: null, errors };
  }
}
